if (!customElements.get('hoculus-cart-checkboxes')) {
  class HoculusCartCheckboxes extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.checkboxArray = this.querySelectorAll('input.obbligatory-check');
      this.selectAllInput = this.querySelector('[id^="select-all-"]');
      this.cartButton = document.getElementById(this.dataset.checkoutId || 'hoculus-cart-drawer-checkout-btn');
      this.expressButtons = this.dataset.expressId ? document.getElementById(this.dataset.expressId) : null;
      this.checkboxArray.forEach(input => input.addEventListener('change', () => this.updateButton()));
      if (this.selectAllInput) {
        this.selectAllInput.addEventListener('change', event => {
          this.checkboxArray.forEach(input => { input.checked = event.target.checked; });
          this.updateButton();
        });
      }
      const form = this.closest('form');
      if (form) {
        form.addEventListener('submit', event => {
          if (event.submitter && event.submitter.name !== 'checkout') return;
          if (!this.allChecked()) {
            event.preventDefault();
            this.updateButton();
            const unchecked = Array.from(this.checkboxArray).find(input => !input.checked);
            if (unchecked) unchecked.focus();
          }
        });
      }
      this.updateButton();
    }
    allChecked() {
      return Array.from(this.checkboxArray).every(input => input.checked);
    }
    updateButton() {
      const allChecked = this.allChecked();
      if (this.cartButton) this.cartButton.disabled = !allChecked;
      if (this.expressButtons) this.expressButtons.hidden = !allChecked;
      if (this.selectAllInput) {
        this.selectAllInput.checked = allChecked;
        this.selectAllInput.indeterminate = !allChecked && Array.from(this.checkboxArray).some(input => input.checked);
      }
    }
  }
  customElements.define('hoculus-cart-checkboxes', HoculusCartCheckboxes);
}
